import React, {useEffect, useState} from 'react';
import {Chip} from '@mui/material';
import {Typography} from '@fupa/fupa-uikit';
import {useHistory} from 'react-router';
import {LastItemsWrapper, LastItems} from 'app/styles/lastItemsStyles';
import styled from 'styled-components';
import ChipImage from 'app/components/chip/ChipImage';
import LocalStorageManager from 'app/services/web-storage/LocalStorageManager';
import {KEY_LAST_COMPETITIONS} from 'app/helpers/lastItemsHelpers';

const Placeholder = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: flex-start;
  justify-content: center;
`;

const defaultImg = {
  path: 'https://image.fupa.net/competition/PEbMHNJZxotP/',
  svg: true,
};

export const LastCompetitions = () => {
  const history = useHistory();
  const [lastCompetitions, setLastCompetitions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const localStorageManager = LocalStorageManager.getInstance();
    const lastCompetitionsFromStorage = localStorageManager.getItem(KEY_LAST_COMPETITIONS);
    setLastCompetitions(lastCompetitionsFromStorage);
    setIsLoading(false);
  }, []);

  const handleClick = (isLeague, slug) => {
    if (isLeague) {
      history.push(`/league/${slug}`);
    } else {
      history.push(`/cup/${slug}`);
    }
  };

  let content;
  if (lastCompetitions && lastCompetitions.length) {
    content = lastCompetitions.map(competition => {
      const {isLeague, slug, name, image: imageSrc} = competition;
      const image = <ChipImage entity='competition' src={imageSrc} circle={true} ratio={'1:1'} fit={true} />;

      return (
        <Chip
          style={{maxWidth: '180px', minWidth: '160px'}}
          key={`lastvisited-${slug}`}
          avatar={image}
          label={name}
          variant='outlined'
          onClick={() => handleClick(isLeague, slug)}
        />
      );
    });
  } else if (isLoading) {
    content = <Placeholder />;
  } else {
    const image = <ChipImage entity='competition' src={defaultImg} circle={true} ratio={'1:1'} fit={true} />;
    const label = 'Noch keine zuletzt besuchten Wettbewerbe';
    content = (
      <Placeholder>
        <Chip style={{borderStyle: 'dashed'}} avatar={image} label={label} variant='outlined' disabled={true} />
      </Placeholder>
    );
  }

  return (
    <LastItemsWrapper>
      <Typography variant='caption1'>Zuletzt besuchte Wettbewerbe</Typography>
      <LastItems>{content}</LastItems>
    </LastItemsWrapper>
  );
};
